<!-- Skip to Main Content Link -->
<a href="#main-content" class="skip-link">Skip to main content</a>

<!-- Accessibility Top Bar -->
<div class="top-bar">
  <div class="container-fluid">
    <div class="top-bar-inner d-flex justify-content-between align-items-center">
      <div class="top-bar-left">
        <span class="top-bar-text d-none d-sm-inline">{{t.header.topbar.govt}}</span>
        <div class="top-bar-divider d-none d-sm-inline"></div>
        <a routerLink="/sitemap" class="top-bar-link" title="Sitemap">
          <i class="material-symbols-outlined">map</i> <span
            class="d-none d-md-inline">{{t.header.topbar.sitemap}}</span>
        </a>
        <div class="top-bar-divider d-none d-sm-inline"></div>
        <a routerLink="/analytics" class="top-bar-link" title="Analytics">
          <i class="material-symbols-outlined">analytics</i> <span
            class="d-none d-md-inline">{{t.header.topbar.analytics}}</span>
        </a>
      </div>
      <div class="top-bar-right d-flex align-items-center">
        <a routerLink="/screen-reader-access" class="top-bar-link" title="Screen Reader Access">
          <i class="material-symbols-outlined">record_voice_over</i> <span
            class="d-none d-md-inline">{{t.header.topbar.screenReader}}</span>
        </a>
        <div class="top-bar-divider"></div>
        <div class="font-controls" role="group" aria-label="Text size controls">
          <button class="font-btn" (click)="changeFontSize('decrease')" title="Decrease font size"
            aria-label="Decrease font size">-A</button>
          <button class="font-btn" (click)="changeFontSize('reset')" title="Reset font size"
            aria-label="Reset font size to default">A</button>
          <button class="font-btn" (click)="changeFontSize('increase')" title="Increase font size"
            aria-label="Increase font size">A+</button>
        </div>
        <div class="top-bar-divider"></div>
        <div class="lang-controls">
          <button class="lang-toggle-btn" type="button" (click)="toggleLanguage()"
            [attr.aria-label]="isEnglishActive ? 'Switch to Odia' : 'Switch to English'">
            <i class="material-symbols-outlined lang-globe-icon">language</i>
            <span class="lang-text">{{ isEnglishActive ? 'ଓଡ଼ିଆ' : 'English' }}</span>
          </button>
        </div>
        <div class="top-bar-divider"></div>
        <!-- <button (click)="toggleApiUrl()" class="dev-api-toggle-btn" type="button">
          <span class="dot" [class.prod]="mode=='prod'"></span>
          <span>API: {{ mode }}</span>
        </button> -->
      </div>
    </div>
  </div>
</div>

<header class="site-header" (keydown)="onKeydown($event)">
  <div class="container-fluid">

    <!-- Branding Row -->
    <div class="site-header-brand-row">

      <!-- Logo & Title -->
      <a routerLink="/" class="site-brand">
        <img src="assets/images/odisha-gov-logo.png" alt="Odisha Logo" class="site-brand-logo">
        <div class="logo-divider" aria-hidden="true"></div>
        <img src="assets/images/culture_dept.png" alt="Culture Dept Logo" class="culture-brand-logo">
        <div class="site-brand-text d-none d-lg-flex">
          <span class="site-brand-main">{{t.header.deptMain}}</span>
          <span class="site-brand-sub">{{t.header.deptSub}}</span>
        </div>
      </a>

      <!-- Dignitaries + Login -->
      <div class="site-header-right">

        <!-- CM -->
        <div class="cm-section d-flex">
          <div class="cm-info-text d-flex">
            <span class="cm-name">{{t.header.cm.name}}</span>
            <span class="cm-role">{{t.header.cm.role}}</span>
          </div>
          <img src="assets/images/mohan-charan-majhi.webp" alt="CM Odisha" class="cm-photo"
            onerror="this.src='assets/images/odisha-logo.png'">
        </div>

        <!-- Separator -->
        <div class="dignitary-separator d-none d-lg-block"></div>

        <!-- State Minister -->
        <div class="cm-section d-flex">
          <div class="cm-info-text d-flex">
            <span class="cm-name">{{t.header.state_minister.name}}</span>
            <span class="cm-role">{{t.header.state_minister.role}}</span>
          </div>
          <img src="assets/images/state_minister.png" alt="State Minister" class="cm-photo"
            onerror="this.src='assets/images/odisha-logo.png'">
        </div>

        <!-- Separator before Login/Home -->
        <div class="dignitary-separator d-none d-xl-block"></div>

        <!-- Login Button -->
        <a class="site-login-btn d-none d-xl-flex" routerLink="/login" *ngIf="!isLoginPage">
          <i class="material-symbols-outlined">login</i>
          <span>{{t.header.login}}</span>
        </a>

        <!-- Home Button (only on login page) -->
        <a class="site-login-btn d-none d-xl-flex" routerLink="/" *ngIf="isLoginPage">
          <i class="material-symbols-outlined">home</i>
          <span>{{t.header.home}}</span>
        </a>

      </div>

    </div> <!-- site-header-brand-row -->

    <!-- Mobile Bottom Bar (Red) -->
    <div class="mobile-bottom-bar d-xl-none">
      <button class="hamburger" type="button" (click)="toggleMobileNav()" [class.is-open]="mobileNavOpen"
        [attr.aria-expanded]="mobileNavOpen" aria-label="Toggle navigation menu" aria-controls="mobileNav">
        <span aria-hidden="true"></span><span aria-hidden="true"></span><span aria-hidden="true"></span>
      </button>

      <a class="nav-helpline-link mobile-bar-helpline" href="tel:+916372901907"
        [attr.aria-label]="t.header.helpline + ': ' + t.header.helplineValue">
        <i class="material-symbols-outlined">phone</i>
        <span class="nav-helpline-label">{{t.header.helpline}}:</span>
        <span class="nav-helpline-number">{{t.header.helplineValue}}</span>
      </a>
    </div>

    <!-- Mobile Info Bar -->
    <!-- Removed as the dignitaries are now shown in the top row on mobile as per screenshot -->

  </div> <!-- container-fluid -->

  <!-- Navigation Row (full width) -->
  <nav class="site-nav d-none d-xl-flex" id="mainNav">

    <a class="site-nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
      <span class="nav-link-label">{{t.header.home}}</span>
    </a>

    <!-- About -->
    <div class="nav-dropdown" *ngIf="menuConfig.about">
      <button class="site-nav-link nav-dropdown-trigger" type="button"
        [class.active]="isActive(['/objective','/guidelines'])" aria-haspopup="true" aria-label="About menu"
        (click)="onTriggerClick($event)">
        <span class="nav-link-label">{{t.header.about.root}} <i class="nav-chevron material-symbols-outlined"
            aria-hidden="true">expand_more</i></span>
      </button>
      <div class="nav-dropdown-panel" role="menu">
        <a class="nav-dropdown-item" routerLink="/objective" routerLinkActive="active" (click)="closeDropdown($event)"
          role="menuitem">
          <i class="material-symbols-outlined" aria-hidden="true">flag</i>
          <span><strong>{{t.header.about.objective.title}}</strong><small>{{t.header.about.objective.desc}}</small></span>
        </a>
        <a class="nav-dropdown-item" href="javascript:void(0)" data-bs-toggle="offcanvas"
          data-bs-target="#guidelinesOffcanvas" (click)="closeDropdown($event)" role="menuitem">
          <i class="material-symbols-outlined" aria-hidden="true">rule</i>
          <span><strong>{{t.header.about.guidelines.title}}</strong><small>{{t.header.about.guidelines.desc}}</small></span>
        </a>
      </div>
    </div>

    <!-- Explore -->
    <div class="nav-dropdown" *ngIf="menuConfig.explore">
      <button class="site-nav-link nav-dropdown-trigger" type="button"
        [class.active]="isActive(['/artcategory','/gallery'])" aria-haspopup="true" aria-label="Explore menu"
        (click)="onTriggerClick($event)">
        <span class="nav-link-label">{{t.header.explore.root}} <i class="nav-chevron material-symbols-outlined"
            aria-hidden="true">expand_more</i></span>
      </button>
      <div class="nav-dropdown-panel" role="menu">
        <a class="nav-dropdown-item" routerLink="/" fragment="artcategory" routerLinkActive="active"
          (click)="navigateToSection('artcategory', $event)" role="menuitem">
          <i class="material-symbols-outlined" aria-hidden="true">palette</i>
          <span><strong>{{t.header.explore.artforms.title}}</strong><small>{{t.header.explore.artforms.desc}}</small></span>
        </a>
        <a class="nav-dropdown-item" routerLink="/" fragment="gallery" routerLinkActive="active"
          (click)="navigateToSection('gallery', $event)" role="menuitem">
          <i class="material-symbols-outlined" aria-hidden="true">photo_library</i>
          <span><strong>{{t.header.explore.gallery.title}}</strong><small>{{t.header.explore.gallery.desc}}</small></span>
        </a>
      </div>
    </div>

    <!-- Register -->
    <div class="nav-dropdown" *ngIf="(menuConfig.troupeRegister && !isRegistrationClosed) || (menuConfig.raRegister && !isAgencyRegistrationClosed)">
      <button class="site-nav-link nav-dropdown-trigger" type="button"
        [class.active]="isActive(['/agency-register','/troupe-register'])" (click)="onTriggerClick($event)">
        <span class="nav-link-label">{{t.header.register.root}} <i
            class="nav-chevron material-symbols-outlined">expand_more</i></span>
      </button>
      <div class="nav-dropdown-panel">
        <a href="javascript:void(0)" class="nav-dropdown-item" routerLinkActive="active" *ngIf="menuConfig.raRegister && !isAgencyRegistrationClosed"
          (click)="forceNavigate('/agency-register','agency',$event); closeDropdown($event)">
          <i class="material-symbols-outlined">corporate_fare</i>
          <span><strong>{{t.header.register.agency.title}}</strong><small>{{t.header.register.agency.desc}}</small></span>
        </a>
        <a href="javascript:void(0)" class="nav-dropdown-item" routerLinkActive="active" *ngIf="menuConfig.troupeRegister && !isRegistrationClosed"
          (click)="forceNavigate('/troupe-register', 'owner', $event)">
          <i class="material-symbols-outlined">manage_accounts</i>
          <span><strong>{{t.header.register.troupeOwner.title}}</strong><small>{{t.header.register.troupeOwner.desc}}</small></span>
        </a>
      </div>
    </div>
    <!-- Help -->
    <div class="nav-dropdown" *ngIf="menuConfig.help">
      <button class="site-nav-link nav-dropdown-trigger" type="button" [class.active]="isActive(['/contact-us'])"
        (click)="onTriggerClick($event)">
        <span class="nav-link-label">{{t.header.help.root}} <i
            class="nav-chevron material-symbols-outlined">expand_more</i></span>
      </button>
      <div class="nav-dropdown-panel">
        <a class="nav-dropdown-item" routerLink="/contact-us" routerLinkActive="active" (click)="closeDropdown($event)">
          <i class="material-symbols-outlined">mail</i>
          <span><strong>{{t.header.help.contact.title}}</strong><small>{{t.header.help.contact.desc}}</small></span>
        </a>
        <a href="javascript:void(0)" class="nav-dropdown-item" routerLinkActive="active"
          (click)="openTutorialModal(); closeDropdown($event)">
          <i class="material-symbols-outlined">ondemand_video</i>
          <span><strong>{{t.header.help.tutorial}}</strong><small>{{t.header.help.tutorialDesc}}</small></span>
        </a>
      </div>
    </div>

    <!-- Helpline & Notification -->
    <div class="nav-actions">
      <!-- Public Notice -->
      <a class="nav-helpline-link" routerLink="/public-notice" title="Public Notice" style="padding: 0.35rem 0.6rem;">
        <i class="material-symbols-outlined">menu_book</i>
      </a>

      <a class="nav-helpline-link" href="tel:+916372901907"
        [attr.aria-label]="t.header.helpline + ': ' + t.header.helplineValue">
        <i class="material-symbols-outlined">phone</i>
        <span class="nav-helpline-label">{{t.header.helpline}}:</span>
        <span class="nav-helpline-number">{{t.header.helplineValue}}</span>
      </a>

      <!-- Notification Bell -->
      <div class="nav-notification-container" style="position: relative; display: inline-block;"
        *ngIf="menuConfig.notifications">
        <a class="nav-notification-btn" (click)="navigateToSection('auditions', $event)" href="javascript:void(0)">
          <i class="material-symbols-outlined nav-bell-icon">notifications</i>
          <span class="nav-bell-label">{{t.header.notifications}}</span>
        </a>
      </div>
    </div>

  </nav>

</header>

<!-- Mobile Nav Sidebar -->
<div class="mobile-nav-wrapper" [class.is-open]="mobileNavOpen">
  <div class="mobile-nav-backdrop" (click)="closeMobileNav()" aria-hidden="true"></div>
  <nav class="mobile-nav" id="mobileNav" [attr.aria-hidden]="!mobileNavOpen" role="dialog" aria-label="Navigation menu"
    aria-modal="true">
    <div class="mobile-nav-header">
      <img src="assets/images/odisha-logo.png" alt="Odisha Logo" class="mobile-nav-logo">
      <button type="button" class="close-mobile-nav" (click)="closeMobileNav()">
        <i class="material-symbols-outlined">close</i>
      </button>
    </div>



    <div class="mobile-nav-content">
      <a class="mobile-nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
        (click)="closeMobileNav()">{{t.header.home}}</a>

      <div class="mobile-nav-group mobile-register-group">
        <div class="mobile-nav-group-title">{{t.header.about.root}}</div>
        <div class="mobile-register-cards">
          <a class="mobile-reg-card" routerLink="/objective" routerLinkActive="active" (click)="closeMobileNav()">
            <span class="mobile-reg-card-icon">
              <i class="material-symbols-outlined">flag</i>
            </span>
            <span class="mobile-reg-card-body">
              <span class="mobile-reg-card-title">{{t.header.about.objective.title}}</span>
              <span class="mobile-reg-card-desc">{{t.header.about.objective.desc}}</span>
            </span>
            <i class="material-symbols-outlined mobile-reg-card-arrow">chevron_right</i>
          </a>

          <a class="mobile-reg-card" href="javascript:void(0)" (click)="openGuidelinesMobile()">
            <span class="mobile-reg-card-icon">
              <i class="material-symbols-outlined">rule</i>
            </span>
            <span class="mobile-reg-card-body">
              <span class="mobile-reg-card-title">{{t.header.about.guidelines.title}}</span>
              <span class="mobile-reg-card-desc">{{t.header.about.guidelines.desc}}</span>
            </span>
            <i class="material-symbols-outlined mobile-reg-card-arrow">chevron_right</i>
          </a>
        </div>
      </div>

      <div class="mobile-nav-group mobile-register-group">
        <div class="mobile-nav-group-title">{{t.header.explore.root}}</div>
        <div class="mobile-register-cards">
          <a class="mobile-reg-card" routerLink="/" fragment="artcategory"
            (click)="navigateToSection('artcategory', $event)">
            <span class="mobile-reg-card-icon">
              <i class="material-symbols-outlined">palette</i>
            </span>
            <span class="mobile-reg-card-body">
              <span class="mobile-reg-card-title">{{t.header.explore.artforms.title}}</span>
              <span class="mobile-reg-card-desc">{{t.header.explore.artforms.desc}}</span>
            </span>
            <i class="material-symbols-outlined mobile-reg-card-arrow">chevron_right</i>
          </a>

          <a class="mobile-reg-card" routerLink="/" fragment="gallery" (click)="navigateToSection('gallery', $event)">
            <span class="mobile-reg-card-icon">
              <i class="material-symbols-outlined">photo_library</i>
            </span>
            <span class="mobile-reg-card-body">
              <span class="mobile-reg-card-title">{{t.header.explore.gallery.title}}</span>
              <span class="mobile-reg-card-desc">{{t.header.explore.gallery.desc}}</span>
            </span>
            <i class="material-symbols-outlined mobile-reg-card-arrow">chevron_right</i>
          </a>
        </div>
      </div>

      <div class="mobile-nav-group mobile-register-group"
        *ngIf="(menuConfig.troupeRegister && !isRegistrationClosed) || (menuConfig.raRegister && !isAgencyRegistrationClosed)">
        <div class="mobile-nav-group-title">{{t.header.register.root}}</div>
        <div class="mobile-register-cards">
          <a class="mobile-reg-card" *ngIf="menuConfig.raRegister && !isAgencyRegistrationClosed" [routerLink]="isProduction ? null : '/agency-register'" routerLinkActive="active"
            (click)="onRegistrationClick($event)">
            <span class="mobile-reg-card-icon">
              <i class="material-symbols-outlined">corporate_fare</i>
            </span>
            <span class="mobile-reg-card-body">
              <span class="mobile-reg-card-title">{{t.header.register.agency.title}}</span>
              <span class="mobile-reg-card-desc">{{t.header.register.agency.desc}}</span>
            </span>
            <i class="material-symbols-outlined mobile-reg-card-arrow">chevron_right</i>
          </a>

          <a class="mobile-reg-card" *ngIf="menuConfig.troupeRegister && !isRegistrationClosed"
            [routerLink]="isProduction ? null : '/troupe-register'" [queryParams]="{role:'owner'}"
            routerLinkActive="active" (click)="onRegistrationClick($event)">
            <span class="mobile-reg-card-icon">
              <i class="material-symbols-outlined">manage_accounts</i>
            </span>
            <span class="mobile-reg-card-body">
              <span class="mobile-reg-card-title">{{t.header.register.troupeOwner.title}}</span>
              <span class="mobile-reg-card-desc">{{t.header.register.troupeOwner.desc}}</span>
            </span>
            <i class="material-symbols-outlined mobile-reg-card-arrow">chevron_right</i>
          </a>

          <!-- Standalone member registration retired: members are added by the
               troupe owner during troupe registration. -->

          <!-- <a class="mobile-reg-card" routerLink="/check-status" routerLinkActive="active" (click)="closeMobileNav()">
            <span class="mobile-reg-card-icon mobile-reg-card-icon--accent">
              <i class="material-symbols-outlined">track_changes</i>
            </span>
            <span class="mobile-reg-card-body">
              <span class="mobile-reg-card-title">{{t.header.register.checkStatus.title}}</span>
              <span class="mobile-reg-card-desc">{{t.header.register.checkStatus.desc}}</span>
            </span>
            <i class="material-symbols-outlined mobile-reg-card-arrow">chevron_right</i>
          </a> -->
        </div>
      </div>

      <div class="mobile-nav-group">
        <div class="mobile-nav-group-title">{{t.header.help.root}}</div>
        <div class="mobile-register-cards">
          <a class="mobile-reg-card" routerLink="/contact-us" routerLinkActive="active" (click)="closeMobileNav()">
            <span class="mobile-reg-card-icon">
              <i class="material-symbols-outlined">mail</i>
            </span>
            <span class="mobile-reg-card-body">
              <span class="mobile-reg-card-title">{{t.header.help.contact.title}}</span>
              <span class="mobile-reg-card-desc">{{t.header.help.contact.desc}}</span>
            </span>
            <i class="material-symbols-outlined mobile-reg-card-arrow">chevron_right</i>
          </a>
          <a class="mobile-reg-card" href="javascript:void(0)" (click)="openTutorialModal(); closeMobileNav()">
            <span class="mobile-reg-card-icon">
              <i class="material-symbols-outlined">video_library</i>
            </span>
            <span class="mobile-reg-card-body">
              <span class="mobile-reg-card-title">{{t.header.help.tutorial}}</span>
              <span class="mobile-reg-card-desc">{{t.header.help.tutorialDesc}}</span>
            </span>
            <i class="material-symbols-outlined mobile-reg-card-arrow">chevron_right</i>
          </a>
        </div>
      </div>

      <a class="mobile-nav-link mobile-notification-link" routerLink="/" fragment="auditions"
        (click)="navigateToSection('auditions', $event)">
        <i class="material-symbols-outlined">notifications</i> Notifications
      </a>



      <a class="site-login-btn mobile-login" routerLink="/login" (click)="closeMobileNav()"
        *ngIf="!isLoginPage">{{t.header.login}}</a>
    </div>
  </nav>
</div>

<!-- ═══════════════════════════════════════════════════════════
     GUIDELINES OFFCANVAS
════════════════════════════════════════════════════════════ -->
<div class="offcanvas offcanvas-end guidelines-offcanvas" tabindex="-1" id="guidelinesOffcanvas"
  aria-labelledby="guidelinesOffcanvasLabel">

  <!-- ── Header ── -->
  <div class="gl-offcanvas-header">
    <div class="gl-header-left">
      <i class="material-symbols-outlined gl-header-icon">description</i>
      <span class="gl-header-title" id="guidelinesOffcanvasLabel">
        {{ isEnglishActive ? 'User Guidelines' : 'ବ୍ୟବହାରକାରୀ ନିର୍ଦ୍ଦେଶାବଳୀ' }}
      </span>
    </div>
    <button type="button" class="gl-close-btn" data-bs-dismiss="offcanvas" aria-label="Close">
      <i class="material-symbols-outlined">close</i>
    </button>
  </div>

  <!-- ── Body ── -->
  <div class="gl-offcanvas-body" [class.lang-or]="!isEnglishActive">

    <!-- PDF Banner -->
    <div class="gl-pdf-banner">
      <div class="gl-pdf-left">
        <i class="material-symbols-outlined gl-pdf-icon">picture_as_pdf</i>
        <div>
          <div class="gl-pdf-title">
            {{ isEnglishActive ? 'Ama Kalakara Guidelines' : 'ଆମ କଳାକାର ମାର୍ଗଦର୍ଶିକା' }}
          </div>
          <div class="gl-pdf-filename">Ama Kalakara Guidelines.pdf</div>
        </div>
      </div>
      <div class="gl-pdf-actions">
        <a href="assets/data/Amakalakara_Guideline.pdf" target="_blank" class="gl-pdf-btn gl-pdf-btn--outline">
          <i class="material-symbols-outlined">visibility</i>
          {{ isEnglishActive ? 'View' : 'ଦେଖନ୍ତୁ' }}
        </a>
        <a href="assets/data/Amakalakara_Guideline.pdf" download="Amakalakara_Guideline.pdf"
          class="gl-pdf-btn gl-pdf-btn--fill">
          <i class="material-symbols-outlined">download</i>
          {{ isEnglishActive ? 'Download' : 'ଡାଉନଲୋଡ୍' }}
        </a>
      </div>
    </div>

    <!-- ══════════════ DYNAMIC GUIDELINES FROM JSON ══════════════ -->
    <ng-container *ngFor="let section of guidelinesData">
      <div class="gl-accordion-item">
        <button class="gl-accordion-hdr" (click)="toggleGl(section.id)" [attr.aria-expanded]="glOpen[section.id]">
          <span class="gl-acc-title">{{ currentLang === 'en' ? section.en.title : (section.or?.title || section.en.title) }}</span>
          <i class="material-symbols-outlined gl-acc-chevron" [class.open]="glOpen[section.id]">expand_more</i>
        </button>

        <div class="gl-accordion-body" *ngIf="glOpen[section.id]">
          
          <ng-container *ngIf="currentLang === 'en'">
            <!-- Definitions Type -->
            <ng-container *ngIf="section.type === 'definitions'">
              <div class="gl-def-card" *ngFor="let item of section.en.items">
                <span class="gl-def-badge gl-def-badge--{{item.badgeColor}}">{{item.badge}}</span>
                <div class="gl-def-body">
                  <h6 class="gl-def-title">{{item.title}}</h6>
                  <p class="gl-def-text">{{item.text}}</p>
                </div>
              </div>
            </ng-container>

            <!-- Registration Type -->
            <ng-container *ngIf="section.type === 'registration'">
              <p class="gl-body-text" *ngIf="section.en.bodyText">{{section.en.bodyText}}</p>
              <ul class="gl-check-list" *ngIf="section.en.checklist">
                <li *ngFor="let item of section.en.checklist"><span class="gl-check">✔</span><span>{{item}}</span></li>
              </ul>
            </ng-container>

            <!-- Programmes Type -->
            <ng-container *ngIf="section.type === 'programmes'">
              <p class="gl-body-text" *ngIf="section.en.bodyText">{{section.en.bodyText}}</p>
              <div class="gl-art-group mb-4" *ngFor="let group of section.en.groups">
                <h6 class="gl-art-heading">{{group.heading}}</h6>
                <div class="gl-tag-wrap mt-2">
                  <span class="gl-tag" *ngFor="let tag of group.tags">{{tag}}</span>
                </div>
              </div>
            </ng-container>
            <!-- Art Forms Type -->
            <ng-container *ngIf="section.type === 'artforms'">
              <div class="gl-art-group" *ngFor="let group of section.en.groups">
                <h6 class="gl-art-heading">{{group.heading}}</h6>
                <p class="gl-art-text" *ngFor="let item of group.items">
                  <strong *ngIf="item.label">{{item.label}}:</strong> {{item.text}}
                </p>
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="currentLang === 'or'">
            <!-- Definitions Type (Odia) -->
            <ng-container *ngIf="section.type === 'definitions'">
              <div class="gl-def-card" *ngFor="let item of (section.or?.items || section.en.items)">
                <span class="gl-def-badge gl-def-badge--{{item.badgeColor}}">{{item.badge}}</span>
                <div class="gl-def-body">
                  <h6 class="gl-def-title">{{item.title}}</h6>
                  <p class="gl-def-text">{{item.text}}</p>
                </div>
              </div>
            </ng-container>

            <!-- Registration Type (Odia) -->
            <ng-container *ngIf="section.type === 'registration'">
              <p class="gl-body-text" *ngIf="section.or?.bodyText || section.en.bodyText">{{section.or?.bodyText || section.en.bodyText}}</p>
              <ul class="gl-check-list" *ngIf="section.or?.checklist || section.en.checklist">
                <li *ngFor="let item of (section.or?.checklist || section.en.checklist)"><span class="gl-check">✔</span><span>{{item}}</span></li>
              </ul>
            </ng-container>

            <!-- Programmes Type (Odia) -->
            <ng-container *ngIf="section.type === 'programmes'">
              <p class="gl-body-text" *ngIf="section.or?.bodyText || section.en.bodyText">{{section.or?.bodyText || section.en.bodyText}}</p>
              <div class="gl-art-group mb-4" *ngFor="let group of (section.or?.groups || section.en.groups)">
                <h6 class="gl-art-heading">{{group.heading}}</h6>
                <div class="gl-tag-wrap mt-2">
                  <span class="gl-tag" *ngFor="let tag of group.tags">{{tag}}</span>
                </div>
              </div>
            </ng-container>

            <!-- Art Forms Type (Odia) -->
            <ng-container *ngIf="section.type === 'artforms'">
              <div class="gl-art-group" *ngFor="let group of (section.or?.groups || section.en.groups)">
                <h6 class="gl-art-heading">{{group.heading}}</h6>
                <p class="gl-art-text" *ngFor="let item of group.items">
                  <strong *ngIf="item.label">{{item.label}}:</strong> {{item.text}}
                </p>
              </div>
            </ng-container>
          </ng-container>

        </div>
      </div>
    </ng-container>

  </div><!-- /gl-offcanvas-body -->
</div>

<!-- ═══════════════════════════════════════════════════════════
     TUTORIAL VIDEO MODAL
     ════════════════════════════════════════════════════════════ -->
<div class="tutorial-modal-overlay" *ngIf="showTutorialModal" (click)="closeTutorialModal()">
  <div class="tutorial-modal-card" (click)="$event.stopPropagation()">
    <div class="tutorial-modal-header">
      <div class="tutorial-header-left">
        <i class="material-symbols-outlined tutorial-header-icon">video_library</i>
        <h4 class="tutorial-header-title">
          {{ isEnglishActive ? 'Registration Tutorials' : 'ପଞ୍ଜୀକରଣ ଭିଡିଓ ସହାୟତା' }}
        </h4>
      </div>
      <button class="tutorial-close-btn" (click)="closeTutorialModal()">
        <i class="material-symbols-outlined">close</i>
      </button>
    </div>

    <div class="tutorial-modal-body">
      <!-- Left sidebar: Select tutorial -->
      <div class="tutorial-sidebar">
        <button *ngFor="let video of tutorials" class="tutorial-sidebar-item"
          [class.active]="activeVideoId === video.id" (click)="selectTutorialVideo(video)">
          <span class="tutorial-item-icon">
            <i class="material-symbols-outlined">play_circle</i>
          </span>
          <span class="tutorial-item-text">
            {{ isEnglishActive ? video.descEn : video.descOr }}
          </span>
        </button>
      </div>

      <!-- Right: Embedded Player -->
      <div class="tutorial-player-container">
        <div class="tutorial-video-wrapper" *ngIf="selectedTutorialVideoUrl">
          <iframe [src]="selectedTutorialVideoUrl" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ============================================================ -->
<!-- BLOCKING ACCESS CODE MODAL                                   -->
<!-- ============================================================ -->
<div class="access-code-overlay" *ngIf="showAccessCodeModal">
  <div class="access-code-card">
    <div class="access-code-header">
      <span class="material-symbols-outlined access-lock-icon">lock</span>
      <h3>{{ currentLang === 'or' ? 'ପ୍ରବେଶ ସଙ୍କେତ ଆବଶ୍ୟକ' : 'Access Code Required' }}</h3>
      <p>{{ currentLang === 'or' ? 'ଏହି ୱେବସାଇଟ୍ ଦେଖିବା ପାଇଁ ଦୟାକରି ସଠିକ୍ ପ୍ରବେଶ ସଙ୍କେତ ପ୍ରବେଶ କରନ୍ତୁ।' : 'Please enter
        the access code to view the website.' }}</p>
      <div class="dev-warning-box">
        {{ currentLang === 'or' ? 'ଏହି ସାଇଟ୍ କେବଳ ଡେଭଲପର୍ ମାନଙ୍କ ପାଇଁ ଅଟେ। ଦୟାକରି ଅଫିସିଆଲ୍ ୱେବସାଇଟ୍ ପରିଦର୍ଶନ କରନ୍ତୁ:' :
        'This site is only for developers. Please visit the official website' }}
        <a href="https://amakalakara.odisha.gov.in" target="_blank"
          rel="noopener noreferrer">https://amakalakara.odisha.gov.in</a>
      </div>
    </div>

    <div class="access-code-form">
      <div class="input-group-custom">
        <input type="password" [placeholder]="currentLang === 'or' ? 'ପ୍ରବେଶ ସଙ୍କେତ ଦିଅନ୍ତୁ' : 'Enter Access Code'"
          [value]="enteredAccessCode" (input)="onAccessCodeInput($event)" (keydown.enter)="submitAccessCode()"
          [class.input-error]="accessCodeError" autofocus>
      </div>

      <div class="error-text-custom" *ngIf="accessCodeError">
        <span class="material-symbols-outlined">error</span>
        <span>{{ currentLang === 'or' ? 'ଭୁଲ୍ ପ୍ରବେଶ ସଙ୍କେତ!' : 'Invalid access code!' }}</span>
      </div>

      <button class="btn-access-submit" (click)="submitAccessCode()">
        {{ currentLang === 'or' ? 'ଯାଞ୍ଚ କରନ୍ତୁ' : 'Verify' }}
      </button>
    </div>
  </div>
</div>